/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Single_Status_FailedInputs */

const en_orders_single_status_failed = /** @type {(inputs: Orders_Single_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update order status`)
};

const es_orders_single_status_failed = /** @type {(inputs: Orders_Single_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar el estado del pedido`)
};

/**
* | output |
* | --- |
* | "Failed to update order status" |
*
* @param {Orders_Single_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_single_status_failed = /** @type {((inputs?: Orders_Single_Status_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Single_Status_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_single_status_failed(inputs)
	return es_orders_single_status_failed(inputs)
});